"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLink = exports.LinkProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
// LinkContext allows a consuming application to inject a
// custom component to be used for nav links & buttons into
// decodable-ui. In this way, the consumer can connection
// decodable-ui into their routing solution of choice -
// typically react-router. The provided component must handle
// adapting the MUI Button/Link props API to the external
// router's components.
//
// See: https://mui.com/guides/routing/
const LinkContext = (0, react_1.createContext)(null);
function LinkProvider({ value, children }) {
    return (0, jsx_runtime_1.jsx)(LinkContext.Provider, Object.assign({ value: value }, { children: children }));
}
exports.LinkProvider = LinkProvider;
function useLink() {
    const value = (0, react_1.useContext)(LinkContext);
    return value;
}
exports.useLink = useLink;
